import { render, staticRenderFns } from "./itDeclarationDashboard.vue?vue&type=template&id=7333329e&scoped=true"
import script from "./itDeclarationDashboard.vue?vue&type=script&lang=js"
export * from "./itDeclarationDashboard.vue?vue&type=script&lang=js"
import style0 from "./itDeclarationDashboard.vue?vue&type=style&index=0&id=7333329e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7333329e",
  null
  
)

export default component.exports